<template>
  <div class="score-info">
    <div class="score-time">
      <h1 class="time is-5 has-text-centered">
        {{ ended ? "FT" : time + "'" }}
      </h1>
      <span v-if="firstTime" class="goal-mini">
        НТ: {{ firstTime.home }} - {{ firstTime.away }}
      </span>
    </div>
    <div class="goals">
      <div class="goal">
        <span
          class="goal-text"
          :style="{
            color:
              isHomeGoal || isHomeNoGoal
                ? 'var(--danger-color)'
                : 'var(--fontColor)',
          }"
        >
          {{ homeScore }}

          <h3 v-if="isHomeGoal" class="score_change right">Goal!!!</h3>
          <h3 v-if="isHomeNoGoal" class="score_change canceled right">
            Goal Cancelled
          </h3>
        </span>
      </div>
      <div class="selector"></div>
      <div class="goal">
        <span
          class="goal-text"
          :style="{
            color:
              isAwayGoal || isAwayNoGoal
                ? 'var(--danger-color)'
                : 'var(--fontColor)',
          }"
        >
          {{ awayScore }}
          <h3 v-if="isAwayGoal" class="score_change left">Goal!!!</h3>
          <h3 v-if="isAwayNoGoal" class="score_change canceled left">
            Goal Cancelled
          </h3>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScoreInfo",
  props: {
    time: { type: Number, require: true },
    homeScore: { type: Number, require: true },
    awayScore: { type: Number, require: true },
    id: { type: Number, require: true },
    keyName: { type: String, require: true },
    isHomeGoal: { type: Boolean, default: false },
    isAwayGoal: { type: Boolean, default: false },
    isHomeNoGoal: { type: Boolean, default: false },
    isAwayNoGoal: { type: Boolean, default: false },
    firstTime: { type: [Object, Boolean], default: false },
    ended: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@use "../../scss/variables" as *;

.score-info {
  display: flex;
  flex-direction: column;
  align-items: center;

  .selector {
    height: 14px;
    width: 1px;
    background-color: rgb(197, 197, 197);
  }

  .time {
    color: var(--font-color);
    font-weight: 700;
    line-height: 30.05px;
    font-size: 24px;
    text-align: center;
  }

  .goals {
    display: flex;
    align-items: center;
    padding: 10px;
    background-color: var(--shots-body-color);
    border-radius: 26px;
    margin-top: 10px;

    .goal {
      display: flex;
      height: 30px;
      width: 50px;
      justify-content: center;
    }

    .goal-text {
      position: relative;
      font-weight: 700;
      font-size: 24px;
      line-height: 30.05px;
      color: var(--font-color);
    }

    .score_change {
      position: absolute;
      bottom: 60px;
      font-size: 20px;
      color: var(--danger-color);
      background-color: #fff;
      border-radius: 16px;
      padding: 5px 12px;
      text-transform: uppercase;
      font-family: sans-serif;
      font-weight: bolder;
      animation: goal 1s infinite;
      transform-origin: center;
    }

    .canceled {
      font-size: 17px;
      padding: 5px;
      text-align: center;
      line-height: 16px;
    }

    .left {
      left: 12px;
    }

    .right {
      right: 12px;
    }
  }
}

.score-time {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

@media screen and (max-width: $tablet) {
  .score-info {
    flex-direction: row;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: 190px;

    .time {
      font-size: 40px;
    }

    .selector {
      height: 1px;
      width: 14px;
    }

    .goals {
      flex-flow: column;
      margin-top: 0;
      margin-left: 41px;
      padding: 20px 0;
      width: 50px;
      max-height: 170px;
      height: 100%;
      justify-content: space-between;
      gap: 2px;

      .goal {
        height: 40px;
        align-items: center;
      }

      .score_change {
        right: 65px;
        left: auto;
        bottom: auto;
        font-size: 20px;
      }

      .right {
        bottom: 20px;
      }

      .left {
        top: 40px;
      }

      .goals-block {
        height: 1px;
        width: 14px;
        background-color: #c5c5c5;
      }
    }
  }
}

@media screen and (max-width: $mobile) {
  .goal-mini {
    white-space: nowrap;
  }

  .score-info {
    justify-content: end;
    min-width: 110px;
    min-height: 170px;

    .time {
      font-size: 22px;
    }

    .goals {
      margin-left: 10px;
      height: auto;

      .goal-text {
        line-height: 10px;
      }

      .score_change {
        right: 15px;
        font-size: 16px;
        line-height: 30px;
      }

      .canceled {
        font-size: 14px;
        padding: 5px;
        text-align: center;
        line-height: 15px;
      }

      .right {
        top: auto;
        bottom: 35px;
      }

      .left {
        top: 45px;
      }
    }
  }
}

@keyframes goal {
  0% {
    transform: translateY(0) scale(1);
  }

  50% {
    transform: translateY(-10px) scale(1.1);
  }

  100% {
    transform: translateY(0) scale(1);
  }
}
</style>
